<template>
  <b-button
    type="submit"
    variant="primary"
    :disabled="isLoading"
    v-on="$listeners"
  >
    <b-spinner
      v-if="isLoading"
      small
      type="grow"
      style="position: relative; bottom: 2px;"
      class="mx-2"
    ></b-spinner>
    {{ submitButtonText }}</b-button
  >
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "gwzButton",
  props: {
    submitButtonText: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["isLoading"])
  }
};
</script>

<style scoped></style>
